export const aciArrowLeft = {
    iconName: 'arrow-left',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M16.376 2.051c-.087.041-.957.902-4.705 4.654-2.958 2.96-4.618 4.638-4.654 4.7-.116.205-.148.331-.148.595 0 .264.032.39.148.594.036.063 1.696 1.74 4.654 4.7 3.748 3.753 4.619 4.614 4.705 4.655a.577.577 0 00.447.011.641.641 0 00.286-.314.624.624 0 00-.021-.39c-.034-.076-1.014-1.067-4.606-4.66-2.51-2.51-4.563-4.579-4.563-4.596 0-.017 2.053-2.085 4.563-4.596 3.592-3.593 4.572-4.584 4.606-4.66a.624.624 0 00.02-.39.641.641 0 00-.285-.314.577.577 0 00-.447.011z',
                fill: 'currentColor',
            },
        },
    },
};
